module.exports = __webpack_public_path__ + "img/xmasParty15.559e3e41.jpg";